/**
 * TanStack Query hooks for `igaming-bank-transfer-e-wallet-crypto-disbursement`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingBankTransferEWalletCryptoDisbursementQueryKeys,
	type CreateIgamingBankTransferEWalletCryptoDisbursementBody,
	type ListIgamingBankTransferEWalletCryptoDisbursementResponse,
	type IgamingBankTransferEWalletCryptoDisbursementRow,
} from "./api";

export function useIgamingBankTransferEWalletCryptoDisbursementList(): UseQueryResult<ListIgamingBankTransferEWalletCryptoDisbursementResponse, Error> {
	return useQuery({
		queryKey: igamingBankTransferEWalletCryptoDisbursementQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingBankTransferEWalletCryptoDisbursementCreate(): UseMutationResult<IgamingBankTransferEWalletCryptoDisbursementRow, Error, CreateIgamingBankTransferEWalletCryptoDisbursementBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBankTransferEWalletCryptoDisbursementQueryKeys.all });
		},
	});
}

export function useIgamingBankTransferEWalletCryptoDisbursementDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBankTransferEWalletCryptoDisbursementQueryKeys.all });
		},
	});
}
